<template>
    <div>
        <v-server-table ref="remindersTable" url="/profile/reminders/list" :columns="columns" :options="options">
            <template slot="inspection_reminder_id" slot-scope="props">
                <router-link :to="`/profile/reminders/edit/${props.row.inspection_reminder_id}`" title="Edit Goal" class="btn btn-sm btn-light">
                    <i class="fa fa-edit"></i> Edit
                </router-link>
                <button @click="deleteReminder(props.row.inspection_reminder_id)" title="Delete Goal" class="btn btn-sm btn-light" type="button" :disabled="deleting[props.row.inspection_reminder_id]">
                    <span class="text-danger">
                        <template v-if="deleting[props.row.inspection_reminder_id]"><i class="fa fa-spin fa-spinner"></i> Deleting...</template>
                        <template v-else><i class="fa fa-trash"></i> Delete</template>
                    </span>
                </button>
            </template>

            <template slot="form_name" slot-scope="props">
                {{ props.row.form_name ? props.row.form_name : 'All Inspection Forms' }}
            </template>

            <template slot="next_goal" slot-scope="props">
                {{ props.row.next_goal | moment("timezone", userTimezone, "MM/DD/YYYY LT") }}
            </template>

            <template slot="goal" slot-scope="props">
                {{ props.row.goal }} inspection(s) every {{ props.row.repeat_amount }} {{ props.row.repeat_interval }}(s) by {{ readTime(props.row.goal_time) }}
            </template>

            <template slot="child_row" slot-scope="props">
                <div class="form-group">
                    <label class="text-muted">Email Alerts:</label>
                    <div v-for="email in JSON.parse(props.row.reminders)">
                        Send a reminder if <strong>{{ email.goal }}</strong> inspection
                        <template v-if="parseInt(email.goal) > 1">s are </template>
                        <template v-else> is </template>
                        not completed by <strong>{{ readTime(email.time) }}</strong>
                        <template v-if="email.repeat_amount === 0">
                            <template v-if="props.row.repeat_interval === 'day'">
                                the same day
                            </template>
                            <template v-else-if="props.row.repeat_interval === 'week'">
                                within the week
                            </template>
                            <template v-else>
                                within the month
                            </template>
                        </template>
                        <template v-else-if="email.repeat_amount === 1">
                            <template v-if="props.row.repeat_interval === 'day'">
                                the next day
                            </template>
                            <template v-else-if="props.row.repeat_interval === 'week'">
                                next week
                            </template>
                            <template v-else>
                                next month
                            </template>
                        </template>
                        <template v-else>
                            after {{ email.repeat_amount }} {{ props.row.repeat_interval }}s
                        </template>
                    </div>
                </div>
            </template>
        </v-server-table>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {
            user_id: {
                type: Number,
                default: null,
            },

            role_id: {
                type: Number,
                default: null,
            },
        },

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                columns: ['inspection_reminder_id', 'form_name', 'next_goal', 'goal'],
                deleting: {},
                options: {
                    headings: {
                        inspection_reminder_id: 'Actions',
                        inspection_form_name: 'Inspection Form',
                        next_goal: 'Next Goal',
                        goal: 'Goal Period',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'inspection_reminder_id',
                    },
                    uniqueKey: 'inspection_reminder_id',
                    filterable: false,
                    columnsDropdown: false,
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('inspectionGoalList', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //INclude the asset
                        if(this.user_id)
                        {
                            //Set it
                            data.user_id = this.user_id;
                        }

                        //INclude the asset
                        if(this.role_id)
                        {
                            //Set it
                            data.role_id = this.role_id;
                        }

                        //Send it
                        return data;
                    },
                },
            }
        },

        methods: {
            // Convert database timezone/format to human
            readTime(time) {
                return moment(time, 'HH:mm:ss').tz(this.userTimezone).format('LT');
            },

            deleteReminder(id){
                //Set the helper
                this.deleting[id] = true;

                //Sned it
                this.$http.post('/profile/reminders/delete/' + id)
                    .then(response => {
                        //Alert the user
                        this.$toastr.success('Reminder Deleted');

                        //Refresh the list
                        this.$refs.remindersTable.refresh();
                    })
                    .catch(error => {
                        //Alert the user
                        this.$toastr.error(error.response.data);
                    })
                    .then(() => {
                        //Reset
                        this.deleting[id] = false;
                    });
            },
        },

        mounted(){

        }
    }
</script>
